import { render, staticRenderFns } from "./edittestimonial.vue?vue&type=template&id=838f0672&"
import script from "./edittestimonial.vue?vue&type=script&lang=js&"
export * from "./edittestimonial.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports